import { ProFormaFundOwnershipDetailModel, Value } from 'api';
import { GetSharesByFundAndSecurityParams, OwnerType, SecurityForWaterfall } from 'pages/Waterfall/types';

const getSharesByOwnerAndSecurity = ({
  ownerId,
  securityId,
  fundOwnershipDetail,
  owner,
}: GetSharesByFundAndSecurityParams) => {
  const tmpFundOwnershipDetail = fundOwnershipDetail.filter(
    fod => fod[owner] === ownerId && fod.security === securityId
  );
  if (tmpFundOwnershipDetail.length > 0) {
    return tmpFundOwnershipDetail.reduce((acc, curr) => acc + Number(curr.shares), 0);
  }

  return 0;
};

const getOwnerShareValue = ({
  fod,
  securities,
  fundOwnershipDetails,
  sortedPresentValues,
  owner,
  ownerId,
}: {
  fod: ProFormaFundOwnershipDetailModel;
  securities: SecurityForWaterfall[];
  fundOwnershipDetails: ProFormaFundOwnershipDetailModel[];
  sortedPresentValues: Value[];
  owner: OwnerType;
  ownerId: number;
}) => ({
  securityId: fod.security,
  shares: getSharesByOwnerAndSecurity({
    ownerId,
    owner,
    securityId: fod.security as number,
    fundOwnershipDetail: fundOwnershipDetails,
  }),
  security: securities.find(s => s.id === fod.security)?.name,
  per_share: sortedPresentValues.find(presentValue => presentValue.security?.id === fod.security)?.value,
});

export default getOwnerShareValue;
